import ServicePage from "../Common/ServicePage";

// On-Your Own Kitchen specific services
const kitchenServices = [
  { 
    id: 1, 
    name: 'Festival Special Thali', 
    provider: 'Festive Kitchen', 
    image: 'https://placehold.co/600x400?text=Festival+Thali', 
    rating: 4.92, 
    reviews: 1200, 
    price: 899, 
    category: 'Festival Specials' 
  },
  { 
    id: 2, 
    name: 'Family Combo (4 Persons)', 
    provider: 'Family Kitchen', 
    image: 'https://placehold.co/600x400?text=Family+Combo', 
    rating: 4.88, 
    reviews: 950, 
    price: 1599, 
    category: 'Family Meals' 
  },
  { 
    id: 3, 
    name: 'Sweet Box (Assorted)', 
    provider: 'Sweet Delights', 
    image: 'https://placehold.co/600x400?text=Sweet+Box', 
    rating: 4.95, 
    reviews: 500, 
    price: 699, 
    category: 'Sweets & Desserts' 
  },
  { 
    id: 4, 
    name: 'Traditional Sweets Platter', 
    provider: 'Traditional Kitchen', 
    image: 'https://placehold.co/600x400?text=Traditional+Sweets', 
    rating: 4.85, 
    reviews: 800, 
    price: 299, 
    category: 'Sweets & Desserts' 
  },
  { 
    id: 5, 
    name: 'Snacks & Savories Pack', 
    provider: 'Snack Masters', 
    image: 'https://placehold.co/600x400?text=Snacks+Pack', 
    rating: 4.79, 
    reviews: 650, 
    price: 199, 
    category: 'Snacks' 
  },
  { 
    id: 6, 
    name: 'Custom Meal Orders', 
    provider: 'Custom Kitchen', 
    image: 'https://placehold.co/600x400?text=Custom+Meals', 
    rating: 4.90, 
    reviews: 400, 
    price: 499, 
    category: 'Custom Orders' 
  },
  { 
    id: 7, 
    name: 'Daily Lunch Thali', 
    provider: 'Daily Kitchen', 
    image: 'https://placehold.co/600x400?text=Daily+Lunch', 
    rating: 4.83, 
    reviews: 1200, 
    price: 199, 
    category: 'Daily Meals' 
  },
  { 
    id: 8, 
    name: 'Dinner Special Combo', 
    provider: 'Dinner Specials', 
    image: 'https://placehold.co/600x400?text=Dinner+Combo', 
    rating: 4.86, 
    reviews: 750, 
    price: 299, 
    category: 'Dinner Meals' 
  },
  { 
    id: 9, 
    name: 'Breakfast Package', 
    provider: 'Morning Delights', 
    image: 'https://placehold.co/600x400?text=Breakfast+Package', 
    rating: 4.81, 
    reviews: 600, 
    price: 149, 
    category: 'Breakfast' 
  },
  { 
    id: 10, 
    name: 'Party Platter (10 Persons)', 
    provider: 'Party Kitchen', 
    image: 'https://placehold.co/600x400?text=Party+Platter', 
    rating: 4.89, 
    reviews: 350, 
    price: 2499, 
    category: 'Party Orders' 
  },
  { 
    id: 11, 
    name: 'Diet Meal Plan', 
    provider: 'Healthy Kitchen', 
    image: 'https://placehold.co/600x400?text=Diet+Meals', 
    rating: 4.87, 
    reviews: 280, 
    price: 799, 
    category: 'Special Diets' 
  },
  { 
    id: 12, 
    name: 'Regional Specialties', 
    provider: 'Regional Kitchen', 
    image: 'https://placehold.co/600x400?text=Regional+Food', 
    rating: 4.84, 
    reviews: 420, 
    price: 349, 
    category: 'Regional Cuisine' 
  },
  { 
    id: 13, 
    name: 'Kids Meal Box', 
    provider: 'Kids Kitchen', 
    image: 'https://placehold.co/600x400?text=Kids+Meal', 
    rating: 4.91, 
    reviews: 320, 
    price: 179, 
    category: 'Kids Meals' 
  },
  { 
    id: 14, 
    name: 'Office Lunch Package', 
    provider: 'Office Kitchen', 
    image: 'https://placehold.co/600x400?text=Office+Lunch', 
    rating: 4.82, 
    reviews: 550, 
    price: 1299, 
    category: 'Bulk Orders' 
  }
];

const kitchenCategories = ['Festival Specials', 'Family Meals', 'Sweets & Desserts', 'Snacks', 'Custom Orders', 'Daily Meals', 'Dinner Meals', 'Breakfast', 'Party Orders', 'Special Diets', 'Regional Cuisine', 'Kids Meals', 'Bulk Orders'];

const packages = [
  { id: 1, title: "Festival Special Thali", rating: "4.92 (1,200 reviews)", price: 899, originalPrice: 1099, icon: "🎊" },
  { id: 2, title: "Family Combo (4 Persons)", rating: "4.88 (950 reviews)", price: 1599, originalPrice: 1899, icon: "👨‍👩‍👧‍👦" },
  { id: 3, title: "Sweet Box (Assorted)", rating: "4.95 (500 reviews)", price: 699, originalPrice: 899, icon: "🍰" },
];

const miniServices = [
  { id: 101, title: "Traditional Sweets", price: 299, icon: "🍬" },
  { id: 102, title: "Snacks & Savories", price: 199, icon: "🍕" },
  { id: 103, title: "Custom Orders", price: 499, icon: "🛒" },
];

export default function OnYourOwnKitchen() {
  return (
    <ServicePage
      serviceName="On-Your Own Kitchen"
      packages={packages}
      miniServices={miniServices}
      customServices={kitchenServices}
      customCategories={kitchenCategories}
      isCustomService={true}
    />
  );
}